/*
 * tc-card-collective.js
 * Fetches real prices/availability from Shopify Collective for
 * condition variants linked via collective_variant_id.
 * Updates the card DOM after page load.
 */
(function () {
  if (window.__tcCardCollectiveLoaded) return;
  window.__tcCardCollectiveLoaded = true;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateCard(card) {
    var cvAttr = card.getAttribute('data-collective-variants');
    if (!cvAttr) return;

    var collectiveMap;
    try { collectiveMap = JSON.parse(cvAttr); } catch (e) { return; }

    var variantMapEl = card.querySelector('[data-tc-variant-map]');
    var variantMap;
    try { variantMap = JSON.parse(variantMapEl.textContent); } catch (e) { return; }

    // Group variants by condition, collect collective IDs to fetch
    var fetchList = []; // { localId, collectiveId, condition }
    Object.keys(collectiveMap).forEach(function (localId) {
      var cId = collectiveMap[localId];
      var info = variantMap[localId];
      if (cId && info) {
        fetchList.push({ localId: localId, collectiveId: cId, condition: info.condition });
      }
    });

    if (fetchList.length === 0) return;

    // Fetch all collective variants
    var conditionData = {}; // condition -> { price, compare_at_price, available }

    var fetches = fetchList.map(function (item) {
      return fetch('/variants/' + item.collectiveId + '.js')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var cond = item.condition;
          // Keep the lowest available price per condition
          if (!conditionData[cond] || (data.available && data.price < conditionData[cond].price)) {
            conditionData[cond] = {
              price: data.price,
              compare_at_price: data.compare_at_price || 0,
              available: data.available
            };
          } else if (!conditionData[cond].available && data.available) {
            conditionData[cond] = {
              price: data.price,
              compare_at_price: data.compare_at_price || 0,
              available: data.available
            };
          }
        })
        .catch(function () {});
    });

    Promise.all(fetches).then(function () {
      // Merge local (non-collective) variant prices into conditionData
      // so the minimum reflects ALL variants, not just collective ones
      var collectiveLocalIds = {};
      fetchList.forEach(function (item) { collectiveLocalIds[item.localId] = true; });

      Object.keys(variantMap).forEach(function (localId) {
        if (collectiveLocalIds[localId]) return; // already handled by collective fetch
        var info = variantMap[localId];
        if (!info || !info.condition) return;
        var cond = info.condition;
        var localAvail = info.available;
        var localPrice = info.price;
        var localCompare = info.compare_at_price || 0;

        if (!conditionData[cond]) {
          conditionData[cond] = { price: localPrice, compare_at_price: localCompare, available: localAvail };
        } else if (localAvail && localPrice < conditionData[cond].price) {
          conditionData[cond] = { price: localPrice, compare_at_price: localCompare, available: localAvail };
        } else if (!conditionData[cond].available && localAvail) {
          conditionData[cond] = { price: localPrice, compare_at_price: localCompare, available: localAvail };
        }
      });

      // Find the lowest available price across all conditions
      var lowestPrice = Infinity;
      var lowestCompare = 0;
      var availCount = 0;

      Object.keys(conditionData).forEach(function (cond) {
        var d = conditionData[cond];
        if (d.available) {
          availCount++;
          if (d.price < lowestPrice) {
            lowestPrice = d.price;
            lowestCompare = d.compare_at_price;
          }
        }
      });

      if (lowestPrice === Infinity) return; // all sold out from collective

      // Update main price
      var saleEl = card.querySelector('[data-tc-sale]');
      if (saleEl) saleEl.textContent = formatMoney(lowestPrice);

      // Update MSRP
      var msrpEl = card.querySelector('[data-tc-msrp]');
      if (lowestCompare > lowestPrice) {
        if (msrpEl) {
          msrpEl.textContent = formatMoney(lowestCompare);
          msrpEl.style.display = '';
        } else {
          // Create MSRP element if it didn't exist
          var priceRow = card.querySelector('[data-tc-price]');
          if (priceRow) {
            var s = document.createElement('s');
            s.className = 'tc-card__price-msrp';
            s.setAttribute('data-tc-msrp', '');
            s.textContent = formatMoney(lowestCompare);
            priceRow.appendChild(s);
          }
        }
      } else if (msrpEl) {
        msrpEl.style.display = 'none';
      }

      // Update save chip
      var saveEl = card.querySelector('[data-tc-save]');
      if (lowestCompare > lowestPrice) {
        var savingsAmt = lowestCompare - lowestPrice;
        var savingsPct = Math.round((savingsAmt / lowestCompare) * 100);
        if (savingsPct >= 5) {
          var chipText = lowestPrice < 10000
            ? 'Save ' + savingsPct + '%'
            : 'Save ' + formatMoney(savingsAmt);
          if (saveEl) {
            var chip = saveEl.querySelector('.tc-card__save-chip');
            if (chip) chip.textContent = chipText;
          } else {
            var priceDiv = card.querySelector('[data-tc-price]');
            if (priceDiv) {
              var div = document.createElement('div');
              div.className = 'tc-card__save-below';
              div.setAttribute('data-tc-save', '');
              var span = document.createElement('span');
              span.className = 'tc-card__save-chip';
              span.textContent = chipText;
              div.appendChild(span);
              priceDiv.parentNode.insertBefore(div, priceDiv.nextSibling);
            }
          }
        } else if (saveEl) {
          saveEl.style.display = 'none';
        }
      } else if (saveEl) {
        saveEl.style.display = 'none';
      }

      // Update "From" label — show when 2+ condition variants exist (regardless of availability)
      var totalConditions = new Set();
      Object.values(variantMap).forEach(function (info) {
        if (info.condition) totalConditions.add(info.condition);
      });
      var conditionCount = totalConditions.size;

      var fromEl = card.querySelector('.tc-card__price-from');
      if (conditionCount >= 2 && !fromEl) {
        var priceRow2 = card.querySelector('[data-tc-price]');
        if (priceRow2 && saleEl) {
          var fromSpan = document.createElement('span');
          fromSpan.className = 'tc-card__price-from';
          fromSpan.textContent = 'From';
          priceRow2.insertBefore(fromSpan, saleEl);
        }
      } else if (conditionCount < 2 && fromEl) {
        fromEl.remove();
      }

      // Update variant rows
      var variantRows = card.querySelectorAll('[data-condition]');
      variantRows.forEach(function (row) {
        var cond = row.getAttribute('data-condition');
        var d = conditionData[cond];
        if (!d) return;

        var priceEl = row.querySelector('[data-tc-vprice]');
        var soldOutEl = row.querySelector('.tc-card__variant-sold-out');
        var savingsEl = row.querySelector('.tc-card__variant-savings');

        if (d.available) {
          if (priceEl) {
            priceEl.textContent = formatMoney(d.price);
          } else if (soldOutEl) {
            // Replace sold out with price
            var newPrice = document.createElement('span');
            newPrice.className = 'tc-card__variant-price';
            newPrice.setAttribute('data-tc-vprice', '');
            newPrice.textContent = formatMoney(d.price);
            soldOutEl.replaceWith(newPrice);
          }
          // Update savings
          if (d.compare_at_price > d.price) {
            var vPct = Math.round(((d.compare_at_price - d.price) / d.compare_at_price) * 100);
            if (vPct >= 5) {
              if (savingsEl) {
                savingsEl.textContent = '−' + vPct + '%';
              } else {
                var sav = document.createElement('span');
                sav.className = 'tc-card__variant-savings';
                sav.textContent = '−' + vPct + '%';
                row.appendChild(sav);
              }
            }
          }
        } else {
          // Mark as sold out
          if (priceEl) {
            var so = document.createElement('span');
            so.className = 'tc-card__variant-sold-out';
            so.textContent = 'Sold out';
            priceEl.replaceWith(so);
            if (savingsEl) savingsEl.remove();
          }
        }
      });
    });
  }

  // Run after DOM is ready
  function init() {
    var cards = document.querySelectorAll('.tc-card[data-collective-variants]');
    cards.forEach(updateCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also re-run after Shopify AJAX pagination/filtering updates the grid
  document.addEventListener('shopify:section:load', init);
})();
